import { useEffect, useRef, useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { formatDate, parseDateInput } from '@/lib/format';
import { cn } from '@/lib/cn';

/**
 * Türkçe tarih girişi: "gg.aa.yyyy" metni (klavyeyle hızlı giriş, Delphi cxDateEdit gibi) + takvim düğmesi.
 * Değer saat dilimsiz ISO ("YYYY-MM-DDT00:00:00") olarak taşınır.
 */
export function DateInput({ value, onChange, readOnly, className, withTime }: { value: string | null | undefined; onChange: (iso: string | null) => void; readOnly?: boolean; className?: string; withTime?: boolean }) {
  const shown = value ? formatDate(value, withTime ? true : false) : '';
  const [t, setT] = useState(shown);
  const picker = useRef<HTMLInputElement>(null);
  useEffect(() => setT(shown), [shown]);
  const commit = () => {
    if (t === shown) return;
    if (!t.trim()) { onChange(null); return; }
    const v = /^\d{1,2}$/.test(t.trim()) ? autoComplete(t.trim()) : t;
    const iso = parseDateInput(v);
    if (iso) onChange(iso); else setT(shown);
  };
  return (
    <div className={cn('relative', className)}>
      <input className="inp pr-8" placeholder="gg.aa.yyyy" readOnly={readOnly} value={t} onChange={(e) => setT(e.target.value)} onBlur={commit}
        onKeyDown={(e) => { if (e.key === 'Enter') commit(); }} />
      {!readOnly && (
        <>
          <button type="button" tabIndex={-1} className="absolute right-1.5 top-[6px] muted hover:text-[var(--text)]" onClick={() => picker.current?.showPicker?.()} aria-label="Takvim">
            <CalendarDays size={15} />
          </button>
          <input ref={picker} type="date" tabIndex={-1} className="pointer-events-none absolute bottom-0 right-0 h-0 w-0 opacity-0" value={value ? String(value).slice(0, 10) : ''}
            onChange={(e) => onChange(e.target.value ? `${e.target.value}T00:00:00` : null)} />
        </>
      )}
    </div>
  );
}

/** "15" → bu ayın 15'i (Delphi cxDateEdit kısa giriş davranışı) */
function autoComplete(day: string) {
  const d = new Date();
  return `${day}.${d.getMonth() + 1}.${d.getFullYear()}`;
}
